import React from "react";
import { NewChatDisclaimer } from "../../../NewConstants/NewChatConstants";
import { isNeGDDeployment } from "../../../Actions/Utils";

const NewSessionDisclaimer = ({ selectedLanguage }) => {
  const language = NewChatDisclaimer[selectedLanguage]
    ? selectedLanguage
    : "en";

  return (
    <div
      className="inline-flex items-center gap-1 rounded bg-white px-2 py-1"
      role="status"
    >
      <img
        src={isNeGDDeployment() ? "/Assets/Images/New_session_dis_red.svg" : "/Assets/Images/New_session_dis.svg"}
        alt=""
        className="h-4 w-4 shrink-0"
        width={16}
        height={16}
      />
      <span
        className="text-[13px] font-medium leading-[24.59px] tracking-normal text-center text-[var(--border-color)]"
      >
        {NewChatDisclaimer[language]}
      </span>
    </div>
  );
};

export default NewSessionDisclaimer;
